import { render, staticRenderFns } from "./settings-profile-general.vue?vue&type=template&id=644364a6&"
import script from "./settings-profile-general.ts?vue&type=script&lang=ts&"
export * from "./settings-profile-general.ts?vue&type=script&lang=ts&"
import style0 from "./settings-profile-general.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports